<template>
  <section class="section">
    <div class="colums">
      <div class="column is-paddingless">
        <h1 class="title">My Cars</h1>
      </div>
    </div>
    <div class="columns is-multiline">
      <car-card
        v-for="car in cars"
        v-bind:key="car.id"
        :initial-car="car"
        v-on:refetch-list="$apollo.queries.cars.refetch()"
      />

      <div class="column is-6">
        <div class="box">
          <article class="media">
            <figure class="media-left">
              <figure class="image is-128x128">
                <img src="https://bulma.io/images/placeholders/128x128.png">
              </figure>
            </figure>

            <div class="media-content">
              <div class="content">
                <p class="title">Add new vehicle?</p>

                <a
                  v-if="isNewFormOpened === false"
                   @click="isNewFormOpened = true"
                  class="button is-primary"
                >
                  Add New
                </a>

                <template v-if="isNewFormOpened === true">
                  <div class="field">
                    <label class="label">Make</label>
                    <input
                      type="text"
                      class="input"
                      v-model="$v.make.$model"
                      placeholder="Make"
                      v-bind:class="{'is-danger': $v.make.$error}"
                    >
                    <p v-if="$v.make.$error" class="help is-danger">This value is invalid</p>
                  </div>

                  <div class="field">
                    <label class="label">Model</label>
                    <input
                      type="text"
                      class="input"
                      v-model="$v.model.$model"
                      placeholder="Model"
                      v-bind:class="{'is-danger': $v.model.$error}"
                    >
                    <p v-if="$v.model.$error" class="help is-danger">This value is invalid</p>
                  </div>

                  <div class="field">
                    <label class="label">Manufacturing Year</label>
                    <input
                      type="text"
                      class="input"
                      v-model="$v.year.$model"
                      placeholder="Manufacturing Year"
                      v-bind:class="{'is-danger': $v.year.$error}"
                    >
                    <p v-if="$v.year.$error" class="help is-danger">This value is invalid</p>
                  </div>

                  <div class="field">
                    <label class="label">
                      Odometer at Purchase
                    </label>
                    <input
                      type="text"
                      class="input"
                      v-model="$v.odometer.$model"
                      placeholder="Odometer at Purchase"
                      v-bind:class="{'is-danger': $v.odometer.$error}"
                    >
                    <p v-if="$v.odometer.$error" class="help is-danger">This value is invalid</p>
                  </div>

                  <div class="field">
                    <button class="button is-primary" @click="createCar" :disabled="$v.$invalid">
                      Save
                    </button>
                    <button class="button is-danger" @click="isNewFormOpened = false">
                      Cancel
                    </button>
                  </div>
                </template>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { required, alphaNum, integer } from 'vuelidate/lib/validators';
import CarCard from '../components/car/CarCard.vue';
import CARS from '@/graphql/cars/cars.gql';
import CREATE_CAR from '@/graphql/cars/createCar.gql';

export default {
  name: 'Cars',
  components: { CarCard },
  data() {
    return {
      cars: null,
      isNewFormOpened: false,
      make: '',
      model: '',
      year: '',
      image: '',
      odometer: '',
    };
  },
  validations: {
    make: {
      required,
      alphaNum,
    },
    model: {
      required,
      alphaNum,
    },
    year: {
      required,
      integer,
    },
    // image: {},
    odometer: {
      required,
      integer,
    },
  },
  apollo: {
    cars: CARS,
  },
  methods: {
    createCar() {
      this.$apollo.mutate({
        mutation: CREATE_CAR,
        variables: {
          make: this.make,
          model: this.model,
          year: this.year,
          odometer: this.odometer,
        },
      })
        .then(() => {
          this.isNewFormOpened = false;
          this.$apollo.queries.cars.refetch();
          this.$toasted.success(`${this.make} ${this.model} created!`);

          // reset state
          this.make = '';
          this.model = '';
          this.year = '';
          this.image = '';
          this.odometer = '';
        })
        .catch((error) => {
          this.$toasted.error(error);
        });
    },
  },
};
</script>

<style scoped>

</style>
